import createReactComponent from '../createReactComponent';
export default createReactComponent('menu-deep', 'IconMenuDeep', [
  ['path', { d: 'M4 6h16', key: 'svg-0' }],
  ['path', { d: 'M7 12h13', key: 'svg-1' }],
  ['path', { d: 'M10 18h10', key: 'svg-2' }],
]);
